module.exports = __webpack_public_path__ + "img/hj.66e0f11e.png";